import { useMemo } from 'react';
import { TEAM_SPACE_TABS } from '../team-space.consts';
import useTeamSpaceTrackingEvents from './useTeamSpaceTrackingEvents';

const useOverrideProps = ({
  isEnabled,
  isLoading,
  selectedTab,
  setSelectedTab,
  selectedTeam,
  selectedPdtIteration,
  setSelectedPdtIteration,
  pdtIterations,
  activeIteration,
  trendDuration
}) => {
  const trackingEvents = useTeamSpaceTrackingEvents({ selectedTab });
  const overrideProps = useMemo(() => {
    if (!isEnabled) return {};
    const commonProps = {
      isLoading
    };

    switch (selectedTab) {
      case TEAM_SPACE_TABS.CURRENT:
        return {
          ...commonProps,
          currentTeam: selectedTeam,
          controlledIteration: activeIteration
        };
      case TEAM_SPACE_TABS.COMPLETED:
        return {
          ...commonProps,
          controlledTeam: selectedTeam,
          pdtIteration: selectedPdtIteration
        };
      case TEAM_SPACE_TABS.TREND:
        return {
          ...commonProps,
          controlledTeam: selectedTeam,
          ...(selectedTeam && { duration: trendDuration }),
          pdtIteration: null,
          onClickTrendIteration: clickedPdtIteration => {
            const matchedPdtIteration = pdtIterations.find(
              pdtIteration => pdtIteration.id === clickedPdtIteration.id
            );
            trackingEvents.onViewIterationActivity();
            setSelectedPdtIteration(matchedPdtIteration);
            setSelectedTab(TEAM_SPACE_TABS.COMPLETED);
          }
        };
      default:
        return {};
    }
  }, [
    isLoading,
    selectedTab,
    selectedTeam,
    activeIteration,
    selectedPdtIteration,
    trendDuration
  ]);

  return overrideProps;
};

export default useOverrideProps;
